/* eslint-disable no-shadow */
// import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  profile as state
} from '../store';

export default createReducer(state, {
  SET_PROFILE_INFO: (state, { data: profileInfo }) => ({ ...state, profileInfo }),
});
